export const RUNNING_CLOCKING_DISABLED_HINT =
  'Dragging and editing are disabled because this clocking is running.'

export const RELATED_RUNNING_CLOCKING_DISABLED_HINT =
  'Dragging and editing are disabled because its related clocking is running.'

export const TIMELINE_HOVER_OPEN_DELAY = 1000
